/* eslint-disable quote-props */
export default {
  '01': 'Tiempo de respuesta medidor',
  '02': 'Frecuencia de reporteo',
  '03': 'Mensaje no reconocido',
  '04': 'Confirmación reinicio', // Comando que se recibe de sinamed
  '05': 'Interrupciones de energía',
  '06': 'Valores programados',
  '10': 'Identificador de medidor',
  '20': 'Lectura de Energía',
  '30': 'Instantáneos fase A',
  '40': 'Instantáneos fase C',
  '60': 'Cierre de relevador',
  '50': 'Apertura de relevador',
  '90': 'Estado medidor',
  'B0': 'Error de comunicación',
  'C0': 'Número de medidor erróneo',
  'D0': 'Nula comunicación',
  '70': 'Reporte demandas',
  '80': 'Reporte demandas mensuales',
  'A0': 'Modalidad de medidor',
  'E0': 'Cambio a prepago',
  'F0': 'Cambio a pospago',
  '11': 'Cambio a Normal',
  '21': 'Cambio Bidireccional',
  '31': 'Energías Bidireccionales',
  '41': 'Demandas ambos sentidos',
  '51': 'Instantáneos fase B',
  '61': 'Consumo mensual',
  '71': 'Cambio Unidireccional',
  '81': 'Frecuencias',
  '98': 'Confirmación reinicio', // Comando que se manda al medidor
  '990006': 'Frecuencia de reporteo 1 minuto', // 1 Minuto
  '990012': 'Frecuencia de reporteo 3 minutos', // 3 Minutos
  '99001E': 'Frecuencia de reporteo 5 minutos', // 5 Minutos
  '99003C': 'Frecuencia de reporteo 10 minutos', // 10 Minutos
  '990168': 'Frecuencia de reporteo 1 hora', // 1 Hora
  '9905A0': 'Frecuencia de reporteo 4 horas', // 4 Horas
  '990870': 'Frecuencia de reporteo 6 horas', // 6 Horas
  '990B40': 'Frecuencia de reporteo 8 horas' // 8 Horas
}
